<template>
    <el-dialog ref="DetailDialog" class="specil-project-detail-dialog ah-detail-dialog" :visible="visible" top="6vh" append-to-body :before-close="handleBeforeClose">
        <template slot="title">
            <el-row>
                <el-col :span="16">
                    特定費用項目 <span class="sno"># {{ this.form.poo }}</span>
                </el-col>
                <el-col :span="8"> </el-col>
            </el-row>
        </template>
        <div class="detail-row header">
            <el-row :gutter="40">
                <el-col :sm="14">
                    <div class="detail-block" style="margin-bottom: 5px">
                        <div style="margin: 15px 0 0px 0">
                            <div style="margin-bottom: 8px">
                                <div style="font-size: 15pt; font-weight: bold; margin-top: 5px">
                                    <div v-if="form.typ != 4">
                                        {{ form.nam }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :sm="24">
                    <ahSpecialProjectView :form="form" />
                </el-col>
            </el-row>
        </div>
        <div class="detail-row" style="padding-bottom: 0px">
            <el-row :gutter="40">
                <el-col :span="24">
                    <div class="detail-block">
                        <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>請款審核流程</th>
                                <td>
                                    <ahAuditFlowViewer :items="form.auditFlowItems" size="small" style="margin-bottom: 15px" />
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-col>
                <el-col :sm="12">
                    <div class="detail-block">
                        <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>起始日</th>
                                <td>
                                    {{ form.sdt | dateFormater("YYYY-MM-dd") }}
                                </td>
                            </tr>
                            <tr>
                                <th>結案日</th>
                                <td>
                                    {{ form.edt | dateFormater("YYYY-MM-dd") }}
                                </td>
                            </tr>
                            <tr>
                                <th>資料建立人</th>
                                <td>{{ form.upD_USR }}</td>
                            </tr>
                            <tr>
                                <th>建立時間</th>
                                <td>
                                    {{ form.upD_DAT | dateFormater("YYYY-MM-dd") }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-tabs class="detail-tabs" v-model="currTab" style="margin-top: 20px">
            <el-tab-pane label="支出項目" name="payouts"></el-tab-pane>
        </el-tabs>
        <div class="detail-row" v-if="currTab == 'payouts'" style="margin-bottom: 30px">
            <div class="detail-block">
                <el-row :gutter="40">
                    <el-col :sm="24">
                        <el-table :data="form.payouts" empty-text="沒有支出項目" class="ah-el-data-table" :default-sort="{ prop: 'dat', order: 'ascending' }">
                            <el-table-column type="index"></el-table-column>
                            <el-table-column prop="nam" label="請款狀態" width="110">
                                <template slot-scope="scope">
                                    <PaymentStatusLabel :statusNum="scope.row.sigN_STS" size="small" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="payoo" label="請款單號" width="115">
                                <template slot-scope="scope">
                                    <div class="idx" style="text-decoration: underline; cursor: pointer" @click="onPaymentClick(scope.row.sno)">
                                        {{ scope.row.payoo }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="nam" label="摘要" :show-overflow-tooltip="true"></el-table-column>
                            <el-table-column prop="dat" label="實際付款日" width="150">
                                <template slot-scope="scope">
                                    <span v-if="!(scope.row.sigN_STS === 2 || scope.row.sigN_STS === 3)">(預計)</span>
                                    <span>{{ scope.row.dat | dateFormater("YYYY-MM-dd") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="amt" label="支出金額" align="right" width="130">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.amt" />
                                    <ahTip v-if="scope.row.cny !== form.cny">
                                        <div>
                                            約當{{ getCnyTxt(form.cny) }}：
                                            <Money
                                                :v="
                                                    form.cny === 'TWD'
                                                        ? Math.round(scope.row.amt * scope.row.paY_CNYRAT)
                                                        : Math.round(((scope.row.amt * getCnyRat(scope.row.cny)) / getCnyRat(form.cny)) * 100) / 100
                                                "
                                            />
                                        </div>
                                        <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ form.cny === "TWD" ? scope.row.paY_CNYRAT : getForeignCnyRat(scope.row) }}</div>
                                    </ahTip>
                                </template>
                            </el-table-column>
                            <el-table-column prop="cny" label="幣別" width="80"></el-table-column>
                            <el-table-column prop="" label="總預算餘額" align="right" width="110">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.balanceAmt" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="budgetCny" label="幣別" width="80">
                                {{ form.cny }}
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="detail-row footer right">
            <el-button @click="handleDeleteBtnClick" v-if="form.payouts.length == 0 && !isQR()"> 刪除 </el-button>
            <el-button
                v-if="!isQR()"
                type="primary"
                @click="
                    $router.push({
                        name: 'special-disbursement-project-edit',
                        params: { sno: form.sno },
                    })
                "
            >
                編輯
            </el-button>
        </div>
        <PaymentDetailDialog @close="onPaymentDetailDialogClose" :visible="paymentDetailDialog.visible" :sno="paymentDetailDialog.sno" />
    </el-dialog>
</template>
<script>
import ahAuditFlowViewer from '@/components/ui/ahAuditFlowViewer.vue';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import ahSpecialProjectView from '@/components/dashboard/Finance/SpecialProject/ahSpecialProjectView.vue';
import PaymentDetailDialog from '@/components/dashboard/Payment/PaymentDetailDialog.vue';

export default {
    name: 'SpecialProjectDetailPage',
    components: {
        ahAuditFlowViewer,
        PaymentStatusLabel,
        ahSpecialProjectView,
        PaymentDetailDialog,
    },
    props: ['visible', 'sno', 'onEditClick'],
    data() {
        return {
            currTab: 'payouts',
            form: {
                nam: '',
                sdt: null,
                edt: null,
                amt: 0,
                modifyLogs: [],
                payouts: [],
            },
            paymentDetailDialog: {
                visible: false,
                sno: null,
            },
        };
    },
    watch: {
        sno(newSno) {
            if (newSno) this.fetchDetailData(newSno);
        },
    },
    methods: {
        async fetchDetailData(sno) {
            const loadingTarget = this.$refs.DetailDialog.$el.querySelector('.el-dialog');
            const loading = this.$loading({
                lock: true,
                text: '載入中',
                spinner: 'el-icon-loading',
                target: loadingTarget,
            });
            try {
                const resp = await this.$api({
                    url: `/SpecialProjectManagementPage/GetProjectDetail?Sno=${sno}`,
                    method: 'GET',
                });

                this.form = resp.data.item;

                // 將每個支出項目加上餘額金額 (.balanceAmt)
                this.form.payouts = this.transformPayouts(this.form.amt, this.form.payouts, this.form.cny);

                // 重新排序 (混合paY_DAT 和 pdat，舊到新)
                this.form.payouts.sort((a, b) => {
                    const aDate = a.sigN_STS === 2 || a.sigN_STS === 3 ? a.paY_DAT : a.pdat;
                    const bDate = b.sigN_STS === 2 || b.sigN_STS === 3 ? b.paY_DAT : b.pdat;
                    return aDate - bDate;
                });

                console.log('special project', resp.data);
            } finally {
                loading.close();
            }
        },
        // 將每個支出項目加上餘額金額
        transformPayouts(totalAmt, payouts, payoutCny) {
            const getDat = (payout) => (payout.sigN_STS === 2 || payout.sigN_STS === 3 ? payout.paY_DAT : payout.pdat);

            if (payoutCny === 'TWD') {
                let runningTotal = totalAmt;
                return payouts.map((payout) => {
                    const balanceAmt = runningTotal - Math.round(payout.amt * payout.paY_CNYRAT);
                    runningTotal = balanceAmt;
                    return {
                        ...payout,
                        balanceAmt,
                        dat: getDat(payout),
                    };
                });
            }

            let runningTotal = totalAmt;
            return payouts.map((payout) => {
                const CNY = payout.cny;
                const RAT = this.getCnyRat(CNY);
                const AMT = payoutCny === CNY ? payout.amt : Math.round(((payout.amt * RAT) / this.getCnyRat(payoutCny)) * 100) / 100;
                const balanceAmt = runningTotal - AMT;
                runningTotal = balanceAmt;
                return {
                    ...payout,
                    balanceAmt,
                    dat: getDat(payout),
                };
            });
        },
        getForeignCnyRat(row) {
            const RAT = this.getCnyRat(row.cny) / this.getCnyRat(this.form.cny);
            return RAT >= 0.1 ? Math.round(RAT * 1000) / 1000 : Math.round(RAT * 10000) / 10000;
        },
        // 關閉視窗
        handleBeforeClose() {
            this.$emit('close');
            this.emptyData(); // 為了下次開啟不顯示之前的資料
        },
        emptyData() {
            this.form = {
                nam: '',
                sdt: null,
                edt: null,
                amt: 0,
                modifyLogs: [],
                payouts: [],
            };
        },
        handleDeleteBtnClick() {
            this.$confirm('確認要刪除此特定費用項目？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.submitDelete();
                })
                .catch(() => {});
        },
        submitDelete() {
            console.log('AAA');
            this.$api({
                method: 'DELETE',
                url: '/SpecialProjectManagementPage/DeleteProjectDetail',
                data: { sno: this.form.sno },
            }).then(() => {
                this.$emit('close', true);
            });
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        getCnyTxt(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.cnynam;
            return 1;
        },

        onPaymentClick(sno) {
            this.paymentDetailDialog.visible = true;
            this.paymentDetailDialog.sno = sno;
        },
        onPaymentDetailDialogClose(refresh) {
            this.$emit('update', refresh);
            if (refresh) this.fetchDetailData(this.sno);
            this.paymentDetailDialog.visible = false;
            this.paymentDetailDialog.sno = null;
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.specil-project-detail-dialog {
    &.ah-detail-dialog > .el-dialog {
        max-width: 1150px;
    }
    .title {
        .sub {
            font-size: 10pt;
        }
    }

    .pie-chart {
        // border: 1px solid #ccc;
        width: 250px;
        height: 150px;
        margin: 0 auto 30px auto;
    }

    .info-side {
        min-width: 380px;
    }

    .payout-table {
        border-radius: 15px;
    }
}
</style>
Ｆ
